module.exports = __webpack_public_path__ + "fabbc613f9b3fc9b2b374478d0f712f4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-1080.webp.png
// module id = 166
// module chunks = 0